import { render, staticRenderFns } from "./reportBase.vue?vue&type=template&id=a132fe70&scoped=true&"
import script from "./reportBase.vue?vue&type=script&lang=js&"
export * from "./reportBase.vue?vue&type=script&lang=js&"
import style0 from "./reportBase.vue?vue&type=style&index=0&id=a132fe70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a132fe70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDatePicker,VMenu,VRow})
